<template>
  <tr class="js-modal-trigger" :data-target="`modal-ticket-${ticket['Номер']}`" v-on:click="loadModal(ticket)" style="cursor: pointer" :style="`background-color: ${getColor(ticket['Статус'])}`">
    <td v-for="field in filters.list" :style="(!filters.state) ? '' : 'display: none;'" :key="field.id">{{ ticket[field.id] }}</td>
    <td v-for="field in filters.list" :style="(filters.state && field.status) ? '' : 'display: none;'" :key="field.id">{{ ticket[field.id] }}</td>
  </tr>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "TicketPreview",
  props: {
    filters: Object,
    ticket: Object
  },
  methods: {
    loadModal: function (ticket) {
      this.$store.dispatch('MODAL', {
        status: true,
        data: ticket
      })
      setTimeout(async () => {
        if (this.$store.getters.MODAL.status) {
          this.openModal(ticket['Номер'])
        }
      }, 10)
    },
    openModal: function (id) {
      let modal = document.getElementById(`modal-ticket-${id}`)
      if (!modal.classList.toString().includes('is-active')) {
        modal.classList.add('is-active')
      }
    },
    closeModal: function (id) {
      let modal = document.getElementById(`modal-ticket-${id}`)
      if (modal.classList.toString().includes('is-active')) {
        modal.classList.remove('is-active')
      }
    },
    getColor: function (status) {
      switch (status) {
        case '0. Зарегистрировано':
          return 'rgba(218, 212, 52, 0.3)'
        case '0. На обработке':
          return 'rgba(218, 212, 52, 0.1)'
        case '2. Решено':
          return 'rgba(45, 140, 0, 0.2)'
        default:
          return 'transparent'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  backdrop-filter: blur(10px) grayscale(1);
}
.modal-card {
  min-width: 1200px !important;
  .subtitle {
    color: rgb(140, 0, 45);
    opacity: 0.3;
    font-size: 12px;
  }
}
.modal-background {
  background-color: transparent !important;
}
.is-success {
  background: rgb(45, 140, 0) !important;
  transition: 0.3s;
}
.is-danger {
  background: rgb(140, 0, 45) !important;
  transition: 0.3s;
}

</style>
